// Port of api/fuel/app/classes/filter/search/games/filters/post/limit.php
export default {
	name: 'post.limit',
	priority: 0,
	post: true,
	require: function(config, filter) {
		return filter.limit > 0 && !filter.random
	},
	run: function(config, filter, data, results) {
		results.index = results.index.slice(0, filter.limit)
		return results
	}
}
